import * as React from 'react';
import { SVGProps } from 'react';

const IconSaveSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 1C1.56 1 1 1.56 1 2.25v7.5c0 .69.56 1.25 1.25 1.25h7.5c.69 0 1.25-.56 1.25-1.25V4.018c0-.332-.132-.65-.366-.884L8.866 1.366A1.25 1.25 0 0 0 7.982 1H2.25Zm5.732 1H2v2.018h5.982V2ZM5.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
    />
  </svg>
);
export default IconSaveSizeXs;
